var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCreditCardAmericanExpress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.25h24c.966 0 1.75.784 1.75 1.75v16A1.75 1.75 0 0128 25.75H4A1.75 1.75 0 012.25 24V8c0-.966.784-1.75 1.75-1.75z",
    fill: "#fff",
    stroke: "#D1D1D1",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 23v-2.219h-1.688l-.87-.96-.873.96H14v-4.479h-1.798l2.228-5.046h2.15l.769 1.729v-1.73h2.662l.462 1.304.467-1.303H23V9H9v14h14zm-1.405-2.782H23l-1.858-1.972L23 16.297h-1.382l-1.148 1.259-1.135-1.254h-1.404l1.848 1.958-1.848 1.958h1.363l1.153-1.262 1.148 1.262zm.33-1.967L23 19.395v-2.279l-1.075 1.135zm-6.264 1.061v-.608h2.21v-.883h-2.21v-.609h2.265v-.905h-3.335v3.916h3.335v-.906h-2.265v-.005zm6.282-3.577H23v-3.917h-1.647l-.879 2.439-.873-2.439h-1.675v3.917h1.057V12.99l1.006 2.74h.943l1.007-2.75v2.755h.004zm-5.216 0h1.204l-1.73-3.917h-1.377l-1.73 3.917h1.177l.324-.783h1.803l.33.783zm-.7-1.661h-1.061l.53-1.281.531 1.28z",
    fill: "#0079C1"
  })));
}

export default SvgIconCreditCardAmericanExpress;